export default __webpack_public_path__ + "static/media/Cushion_product.baf0483e.png";